<template>
    <div
        v-if="imageUrl !== undefined"
        class="relay-images-cell"
        data-test-id="relay-images"
        :style="{ '--background-image': `url(${imageUrl})` }"
    >
        <span
            v-if="readyImages.length > 1"
            class="relay-image-count"
            data-test-id="relay-image-count"
            >{{ readyImages.length }}</span
        >
    </div>
    <div
        v-else
        class="relay-images-cell no-image"
        data-test-id="relay-images-no-image"
    ></div>
</template>

<script>
import canToast from '@/mixins/canToast'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'
import relayTypes, { byValue } from '@/constants/relay-types'

export default {
    mixins: [canToast, needsOrganizationSlug],
    props: ['row'],
    computed: {
        imageUrl() {
            let imagePath = this.readyImages.find((image) => image.is_cover_image)?.thumbnail_url

            if (!imagePath) {
                imagePath = this.readyImages?.[0]?.thumbnail_url
            }

            if (!imagePath) {
                const relayType = byValue(this.row.type)

                // Default to EDGE relay image
                imagePath = relayType ? relayType.image : relayTypes.EDGE.image
            }

            return imagePath
        },

        readyImages() {
            return this.row.images.filter((image) => {
                return image.status === 'ready'
            })
        },
    },
}
</script>

<style scoped lang="scss">
.relay-images-cell {
    width: 122px;
    height: 78px;
    background-color: #2b2930;
    background-image: var(--background-image);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    border-radius: 8px;
    position: relative;

    background img {
        display: block;
        width: 100%;
        border-radius: 8px;
    }

    .relay-image-count {
        position: absolute;
        border-radius: 100px;
        background-color: #212628;
        right: 3px;
        bottom: 3px;
        font-size: 11px;
        min-width: 16px;
        line-height: 10px;
        height: 16px;
        text-align: center;
        padding: 3px;
    }

    &.no-image {
        background-image: url('@images/relays/image-missing-icon.svg');
        background-size: auto;
        border: 1px solid #c4c4c4;
        background-color: #2b2930;
    }
}
</style>
